<div class="charts-layout view">
  <aside class="charts-sidebar" *ngIf="ready && !isCurrentSystemType">
    <div class="charts-sidebar__level" *ngFor="let level of hierarchyMenu; let menuIndex = index">
      <div class="charts-sidebar__level__label">
        {{ getStructureTypeLabel(level.contentTypeId) }}:
      </div>

      <div class="charts-sidebar__level__selector" (click)="toggleHierarchyLevel(menuIndex)">
        <div class="charts-sidebar__level__selector__value">
          {{ getMenuSelectedName(level) }}
        </div>
        <div class="charts-sidebar__level__selector__caret" [class.open]="level.expanded">▼</div>
      </div>

      <div class="charts-sidebar__level__items" *ngIf="level.expanded">
        <div
          class="charts-sidebar__level__item"
          [class.active]="getMenuSelectedId(level) === 'ALL'"
          (click)="selectHierarchyEntity(menuIndex, 'ALL')"
        >
          • {{ 'common.all' | transloco }}
        </div>

        <div
          class="charts-sidebar__level__item"
          *ngFor="let entity of getEntitiesForLevel(level)"
          [class.active]="getMenuSelectedId(level) === entity.id"
          (click)="selectHierarchyEntity(menuIndex, entity.id)"
        >
          • {{ entity.name }}
        </div>

        <div class="charts-sidebar__level__loading" *ngIf="level.loading">
          {{ 'common.loading' | transloco }}
        </div>
      </div>
    </div>
  </aside>

  <main class="charts-main">
    <div class="title">
      {{ getStructureTypeLabel(currentContentTypeId) }}
    </div>

    <div class="charts-main__controls" *ngIf="ready">
      <div class="charts-main__controls__row" *ngIf="metricTypes.length > 0">
        <button
          *ngFor="let metricType of metricTypes"
          class="btn btn-chart"
          [class.active]="metricType === selectedMetricType"
          (click)="selectMetric(metricType)"
        >
          {{ getMetricLabel(metricType) }}
        </button>
      </div>
      <div class="charts-main__controls__row" *ngIf="subtypesForMetric.length > 1 && !isFunnelMode">
        <button
          *ngFor="let subtype of subtypesForMetric"
          class="btn btn-chart btn-chart--subtype"
          [class.active]="subtype === selectedSubtype"
          (click)="selectSubtype(subtype)"
        >
          {{ getSubtypeLabel(subtype) }}
        </button>
      </div>
    </div>

    <div *ngIf="loading" class="charts-main__status">
      {{ 'common.loading' | transloco }}
    </div>
    <div *ngIf="error" class="charts-main__status charts-main__status--error">
      {{ error }}
    </div>

    <app-chart [config]="chartConfig" [hideButton]="true"></app-chart>

    <div *ngIf="isFunnelMode && funnelConversions.length > 0" class="charts-main__conversions">
      <div *ngFor="let conv of funnelConversions" class="charts-main__conversions__item">
        {{ conv.label }}
      </div>
    </div>
  </main>
</div>
